// extracted by mini-css-extract-plugin
export default {"container":"dN-z","topReviewHeading":"eN-z","criticalReview":"fN-z","favorableReview":"gN-z","vsSeparator":"hN-z"};